<main class="container mt-4 position-relative">
  <div class="back-link mb-4">
    <a class="click" (click)="goHome()">&larr; Back to Profile</a>
  </div>

  <div class="form-card">
    <h1 class="form-title">Update job advertisement</h1>
    <p class="form-subtitle">Modify the details of your job posting below.</p>

    <form class="job-form" (ngSubmit)="onSubmit()">

      <div class="form-group">
        <label for="job-title">Job Title</label>
        <input type="text" id="job-title" name="title" placeholder="e.g. Product designer" [(ngModel)]="title" required>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="location">Location</label>
          <input type="text" id="location" name="location" placeholder="e.g. Budapest XI. or Remote"
            [(ngModel)]="location" required>
        </div>

        <div class="form-group">
          <label for="employment-type">Employment Type</label>
          <select id="employment-type" name="employmentType" [(ngModel)]="employmentType">
            <option [value]="0">Full-time</option>
            <option [value]="1">Part-time</option>
            <option [value]="2">Internship</option>
            <option [value]="3">Temporary</option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label for="salary">Salary / Payment (Optional)</label>
        <input type="text" id="salary" name="salary" placeholder="e.g. 600 000 Ft / month" [(ngModel)]="salary">
      </div>

      <div class="form-group">
        <label for="tags">Tags (comma separated)</label>
        <input type="text" id="tags" name="tags" placeholder="e.g. Angular, C#, Frontend" [(ngModel)]="tags">
      </div>

      <div class="form-group">
        <label for="shorDescription">Job Short Description</label>
        <textarea class="preview-textarea" id="description" name="shortDescription" rows="3"
          placeholder="Describe the role in short...." [(ngModel)]="shortDescription" required></textarea>
      </div>

      @if(isPreView$ | async){
      <div class="form-group">
        <label>Job Description Preview</label>
        <div class="preview-content" [innerHTML]="preViewmd | async"></div>
        <div class="prev-container">
          <button type="button" class="btn btn-primary button-design" (click)="preView()">
            Back
          </button>
        </div>
      </div>
      } @else {
      <div class="form-group">
        <label for="description">Job Description</label>
        <textarea class="preview-textarea" id="description" name="description" rows="6"
          placeholder="Describe the role, responsibilities, and requirements..." [(ngModel)]="description"
          required></textarea>
        <div class="prev-container">
          <button type="button" class="btn button-design" (click)="preView()">
            PreView
          </button>
        </div>
      </div>
      }

      <div class="form-group border-top pt-4 mt-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <label class="mb-0">Skill Assessments (Tests)</label>
          <button type="button" class="btn btn-outline-success btn-sm" (click)="openAddAssessmentModal()">
            <i class="bi bi-plus-circle me-1"></i> Add Test
          </button>
        </div>

        @if (selectedAssessments.length > 0) {
        <div class="list-group mb-3">
          @for (assessment of selectedAssessments; track assessment.id) {
          <div class="list-group-item d-flex justify-content-between align-items-center bg-light border-0 rounded mb-2">
            <div>
              <h6 class="mb-0 fw-bold">{{ assessment.title }}</h6>
              <small class="text-muted">Difficulty: {{ assessment.difficultyLevel }} • {{ assessment.questions?.length
                || 0 }} questions</small>
            </div>
            <button type="button" class="btn btn-sm text-danger" (click)="removeAssessment(assessment.id)">
              <i class="bi bi-x-circle fs-5"></i>
            </button>
          </div>
          }
        </div>
        } @else {
        <p class="text-muted small mb-3">No tests selected yet. Add a test template to evaluate your applicants.</p>
        }
      </div>

      @if (error) {
      <div class="mb-3 text-center">
        <p class="text-danger fw-bold">{{ error }}</p>
      </div>
      }

      <button type="submit" class="submit-btn mt-2" [disabled]="loading">
        {{ loading ? 'Updating...' : 'Update Advertisement' }}
      </button>
    </form>
  </div>
</main>

@if (showAssessmentModal) {
<div class="modal-backdrop fade show" style="background-color: rgba(0,0,0,0.5);"></div>
<div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content shadow">
      <div class="modal-header border-bottom-0 pb-0">
        <h5 class="modal-title fw-bold">Select a Test Template</h5>
        <button type="button" class="btn-close shadow-none me-1" (click)="closeAssessmentModal()"
          aria-label="Close"></button>
      </div>

      <div class="modal-body py-4">
        <div class="row g-3">
          @for (assessment of availableAssessments; track assessment.id) {
          <div class="col-12 col-md-6">
            <div class="card h-100 border cursor-pointer test-card" (click)="selectAssessment(assessment)">
              <div class="card-body bordersize">
                <h6 class="card-title fw-bold">{{ assessment.title }}</h6>
                <p class="small text-truncate mb-0">{{ assessment.description }}</p>
                <div class="d-flex justify-content-between align-items-center mt-3">
                  <span class="badge bg-secondary bg-opacity-25 color-font">{{ assessment.difficultyLevel }}</span>
                  <span class="text-muted small">{{ assessment.questions?.length || 0 }} Qs</span>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>

      <div class="modal-footer border-top-0 pt-0 justify-content-between">
        <span class="text-muted small">Need a new test?</span>
        <button type="button" class="btn search-btn btn-sm" routerLink="/assessments/create">
          Build New Test
        </button>
      </div>
    </div>
  </div>
</div>
}